var exports = {
  "kL": "GuildWebhooksTab.module__container___eFR3LV",
  "wx": "GuildWebhooksTab.module__header___eFR3LV",
  "DD": "GuildWebhooksTab.module__title___eFR3LV",
  "VA": "GuildWebhooksTab.module__subtitle___eFR3LV",
  "lm": "GuildWebhooksTab.module__notice___eFR3LV",
  "et": "GuildWebhooksTab.module__infoBox___eFR3LV",
  "dc": "GuildWebhooksTab.module__spinnerContainer___eFR3LV",
  "g": "GuildWebhooksTab.module__webhookList___eFR3LV",
  "wp": "GuildWebhooksTab.module__followedSection___eFR3LV",
  "Gf": "GuildWebhooksTab.module__sectionTitle___eFR3LV",
  "yV": "GuildWebhooksTab.module__sectionDescription___eFR3LV",
  "kT": "GuildWebhooksTab.module__followedGroup___eFR3LV",
  "QO": "GuildWebhooksTab.module__followedGroupTitle___eFR3LV",
};

module.exports = exports;
